var _excluded = ["checked", "onChange", "name", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import l, { Fragment as D, createContext as k, useCallback as c, useContext as L, useMemo as b, useState as R, useRef as C } from "react";
import { forwardRefWithAs as A, render as y, compact as G } from "../../utils/render.js";
import { useId as K } from "../../hooks/use-id.js";
import { Keys as T } from "../keyboard.js";
import { isDisabledReactIssue7711 as M } from "../../utils/bugs.js";
import { Label as H, useLabels as x } from "../label/label.js";
import { Description as U, useDescriptions as _ } from "../description/description.js";
import { useResolveButtonType as B } from "../../hooks/use-resolve-button-type.js";
import { useSyncRefs as I } from "../../hooks/use-sync-refs.js";
import { VisuallyHidden as F } from "../../internal/visually-hidden.js";
import { attemptSubmit as W } from "../../utils/form.js";
var m = /*#__PURE__*/k(null);
m.displayName = "GroupContext";
var O = D;

function j(f) {
  var _R = R(null),
      _R2 = _slicedToArray(_R, 2),
      n = _R2[0],
      i = _R2[1],
      _x = x(),
      _x2 = _slicedToArray(_x, 2),
      e = _x2[0],
      a = _x2[1],
      _ref = _(),
      _ref2 = _slicedToArray(_ref, 2),
      o = _ref2[0],
      d = _ref2[1],
      u = b(function () {
    return {
      switch: n,
      setSwitch: i,
      labelledby: e,
      describedby: o
    };
  }, [n, i, e, o]),
      p = {},
      t = f;

  return /*#__PURE__*/l.createElement(d, {
    name: "Switch.Description"
  }, /*#__PURE__*/l.createElement(a, {
    name: "Switch.Label",
    props: {
      onClick: function onClick() {
        !n || (n.click(), n.focus({
          preventScroll: !0
        }));
      }
    }
  }, /*#__PURE__*/l.createElement(m.Provider, {
    value: u
  }, y({
    ourProps: p,
    theirProps: t,
    defaultTag: O,
    name: "Switch.Group"
  }))));
}

var N = "button",
    V = A(function (n, i) {
  var e = n.checked,
      a = n.onChange,
      o = n.name,
      d = n.value,
      u = _objectWithoutProperties(n, _excluded),
      p = "headlessui-switch-".concat(K()),
      t = L(m),
      h = C(null),
      S = I(h, i, t === null ? null : t.setSwitch),
      s = c(function () {
    return a(!e);
  }, [a, e]),
      w = c(function (r) {
    if (M(r.currentTarget)) return r.preventDefault();
    r.preventDefault(), s();
  }, [s]),
      E = c(function (r) {
    r.key === T.Space ? (r.preventDefault(), s()) : r.key === T.Enter && W(r.currentTarget);
  }, [s]),
      P = c(function (r) {
    return r.preventDefault();
  }, []),
      v = b(function () {
    return {
      checked: e
    };
  }, [e]),
      g = {
    id: p,
    ref: S,
    role: "switch",
    type: B(n, h),
    tabIndex: 0,
    "aria-checked": e,
    "aria-labelledby": t == null ? void 0 : t.labelledby,
    "aria-describedby": t == null ? void 0 : t.describedby,
    onClick: w,
    onKeyUp: E,
    onKeyPress: P
  };

  return /*#__PURE__*/l.createElement(l.Fragment, null, o != null && e && /*#__PURE__*/l.createElement(F, _objectSpread({}, G({
    as: "input",
    type: "checkbox",
    hidden: !0,
    readOnly: !0,
    checked: e,
    name: o,
    value: d
  }))), y({
    ourProps: g,
    theirProps: u,
    slot: v,
    defaultTag: N,
    name: "Switch"
  }));
}),
    ce = Object.assign(V, {
  Group: j,
  Label: H,
  Description: U
});
export { ce as Switch };